module.exports = {
  title: "SXR50",
  axiosPrefix: "/dniapi",
  type: "orbi", // Available values: 'router', 'orbi'
  style: "smb-gui gui-2-1", // Reserved. Available values: 'gui-2-1', 'smb-gui gui-2-1'
  wireless: {
    hasAx: 1,
    guestNetwork: 0,
    multiSsid: 1,
    adv: {
      hasBroadcast: 1, // Enable SSID Broadcast
      hasWmm: 1, // Enable WMM (Wi-Fi multimedia) settings
      hasThreshold: 1, // CTS/RTS Threshold (1-2347)
      hasMuMimo: 1, // Enable MU-MIMO
      hasFastRoaming: 1, // Enable Fast Roaming
      hasPmfSelection: 1, // Protected Management Frames (802.11w)
    }
  },
  armor: 0,
  circle: 0,
  autoTimezone: 0,
  insight: 1,
  businessVpn: 0,
  advWizard: 1,
  multiGateway: 1,
  ntpPageSeq: 'tz-server', // or 'server-tz'
  footer: {
    hasTncPolicy: 0,
  }
};
